export default __webpack_public_path__ + "lock-open.ac0658eff24788b7.svg";